import React from 'react';
import { PrimaryButton, SecondaryButton } from '@hz-design-system/web-ui';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';

import { trackGAEvent } from '../../../utils/gaTracking';
import Classes from './SellNudge.scss';

const SellNudge = () => {
  const { t } = useI18nContext();

  return (
    <section className={`PageContent-card PageContent-offset ${Classes.root}`}>
      <div className={Classes.inner}>
        <h2 className={Classes.title}>{t('sell.page.nudge.title')}</h2>
        <p className={Classes.body}>{t('sell.page.nudge.body')}</p>
        <div className={Classes.actions}>
          <SecondaryButton
            as="a"
            href="/m/auto/auto-verkopen/"
            onClick={() => {
              trackGAEvent('checkSellPriceClicked', 'nudge');
            }}
          >
            {t('sell.page.nudge.secondary_cta')}
          </SecondaryButton>
          <PrimaryButton
            as="a"
            href="/plaats/91"
            onClick={() => {
              trackGAEvent('placeAdButtonClicked', 'nudge');
            }}
          >
            {t('sell.page.nudge.cta')}
          </PrimaryButton>
        </div>
      </div>
    </section>
  );
};

export default SellNudge;
